module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsBAMAAADsqkcyAAAAAXNSR0IB2cksfwAAACdQTFRFAAAA////////////////////////////////////////////////rj1KOQAAAA10Uk5TABspy9mIsbBSzJYOvnxy8YAAAAC+SURBVHic7dExCsIwFMbxZ0AodPEIQifX0hv4bIuTg0cIXVzdXDrkCD1IQdBDeCn7XpM0ec3u4jc9/vwIhQL4bXaQWlGmqqqO+xQ+XRNcVZctcY3YRBiAOE6LcNYTj/OETUt8CDNhROKHMBdnMIhtrks1LFlVt4we7V/MPa5HQ9lygR0X2HGJLZ/z02PmH8U1vy+YeDNyfgeY+WONPY+x4xJbLrHlK8wcOomJdzD/pnj83b/L4vznRNZ81tH5BSYhssv5DYg4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--home-hover@2x.png
// module id = 930
// module chunks = 0